import React, { FC, useEffect, useState } from 'react';
import { Input, MeetingUrl, RoomsIcon, Select, } from '@components';
import { Formats, IRoom, setClass } from '@utils';
import { isMobile } from 'react-device-detect';
import { TextField } from '@mui/material';
import { textLengthValidator, urlValidator } from '@helpers';
import { RoomOption } from './RoomOption';
import '../../../../../styles/components/locationBlock.scss';

interface IntervalBlockProp {
  format: string,
  room?: IRoom;
  link?: string;
  rooms: IRoom[];
  isEdit: boolean;
  onUpdateMeeting: (property: 'room' | 'link', value: string | IRoom) => void;
  showError: boolean;
}

export const LocationBlock: FC<IntervalBlockProp> = ({
  format, room, link, rooms, onUpdateMeeting, isEdit, showError,
}) => {
  const getRoom = (roomToFind: IRoom) => (
    !roomToFind
      ? roomToFind
      : rooms.find((value) => roomToFind.conferenceType === value.conferenceType)
  );
  const [selectedRoom, setSelectedRoom] = useState(getRoom(room));
  const onChangeRoom = (newRoom: IRoom) => {
    setSelectedRoom(newRoom);
    onUpdateMeeting('room', newRoom);
  };
  const getHelperText = (linkValue: string) => {
    if (linkValue && !urlValidator(linkValue)) {
      return 'Некорректная ссылка';
    } else if (!textLengthValidator(linkValue)) {
      return 'Превышен максимальный размер поля в 255 символов';
    }
    return '';
  };

  useEffect(() => {
    if (rooms.length > 0) {
      setSelectedRoom(getRoom(room));
    }
  }, [getRoom, room, rooms.length]);

  return (
    <div className="area location">
      {format === Formats.OFFLINE && (
        <>
          <RoomsIcon divClassName="block-icon room-icon" />
          {isEdit
            ? (
              <Select
                classNameRootWrapper="room-select"
                options={rooms}
                value={selectedRoom}
                placeholder="КФЗ *"
                getOptionLabel={(option: IRoom) => `${option.cabinetNumber} ${option.conferenceTitle}`}
                onChange={onChangeRoom}
                error={showError && !room}
                errorText={showError && (!room ? 'Выберите КФЗ' : '')}
                renderOption={(item: IRoom, isSelected: boolean) => (
                  <RoomOption room={item} isSelected={isSelected} />
                )}
                getOptionId={(option: IRoom) => option?.cabinetNumber}
              />
            )
            : (
              <div className="view-meeting-location">
                <Input
                  variant="square"
                  classes="light-disabled"
                  value={selectedRoom ? `${selectedRoom?.cabinetNumber} ${selectedRoom?.conferenceTitle}` : ''}
                  disabled
                />
              </div>
            )}
        </>
      )}
      {format === Formats.ONLINE && (link.trim().length !== 0 || isEdit) && (
        <>
          <MeetingUrl divClassName="url-icon" />
          {isEdit
            ? (
              <TextField
                className={setClass('url-field', isMobile && 'mobile')}
                size="small"
                value={link ?? ''}
                id="meetingLink"
                placeholder="https://meet.google.com"
                onChange={(event) => onUpdateMeeting('link', event.target.value)}
                variant="standard"
                error={showError && link && (!urlValidator(link) || !textLengthValidator(link))}
                helperText={showError && getHelperText(link)}
              />
            )
            : (
              <a
                href={link ?? ''}
                className="view-meeting-link"
              >
                {link}
              </a>
            )}
        </>
      )}
    </div>
  );
};
